
import { defineComponent, reactive, toRefs, ref } from 'vue'

export default defineComponent({
  props: {
    tabName: {
      type: String,
    },
    activeColor: {
      type: String,
    },
    list: {
      type: Array,
    },
    curTabIndex: {
      type: Number
    },
    associateTabIndex: { // 关联品牌
      type: Number
    },
  },
  emits: ['changeTabItem'],
  name: '',
  setup(props, { emit }) {
    const listRef = ref(null)
    const data = reactive({
      curIndex: 0,
      startTime: 0,
      diffTime: 1,
    })
    const methods = {
      changeTabItem(index: number, item: any) {
        if(props.tabName === '价格：' && index !== 0 && props.associateTabIndex === 0) return
        emit('changeTabItem', index, item)
      },
      webViewModel(status: any) {
        window.webViewModel &&
        window.webViewModel.webViewMove &&
        window.webViewModel.webViewMove(status)
      },
    }
    return {
      ...toRefs(data),
      ...methods,
      listRef,
    }
  },
})
